var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"serviceprovider"},[_c('ServiceProvidersForm',{attrs:{"serviceProvider":_vm.serviceProvider,"editServiceProvider":_vm.editServiceProvider},on:{"itemUpdate":_vm.onItemUpdate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }